module.exports = __webpack_public_path__ + "static/media/havecard-2.08b6f0bc.svg";